import { usePresentDocumentList } from "@/api/services/main/regular-document";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { Tab } from "@/components/elements/Tab";
import { TopPage } from "@/components/elements/TopPage";
import { RegularTopPageWarning } from "@/features/regular-document/components/RegularTopPageWarning";
import { useGetTargetQuarter } from "@/features/regular-document/hooks/useGetTargetQuarter";
import { useInitSetup } from "@/providers/InitSetupProvider";
import { AppRoutes } from "@/routes/config";
import { background, divider } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { Box } from "@mui/material";
import { FC } from "react";
import { Outlet, useNavigate } from "react-router-dom";

type TRegularReportLayoutProps = {};

export const RegularReportLayout: FC<TRegularReportLayoutProps> = () => {
  const navigate = useNavigate();
  const { data: presentDocumentListResult, isLoading } = usePresentDocumentList();
  const { isLoading: isInitLoading } = useInitSetup();

  const presentDocumentList = presentDocumentListResult?.data;

  const { targetQuarter } = useGetTargetQuarter();

  if (isLoading || !presentDocumentList || isInitLoading) return <LoadingPage />;
  return (
    <Box>
      <TopPage title="定期届出" description="届出書類1、2のそれぞれのステップを進んで、「届出提出」を押してください" enablePageBack={false} />
      <Box mb={2}>
        <RegularTopPageWarning />
      </Box>
      <Tab
        value={location.pathname}
        onChange={(_, tab) => navigate(tab.toString())}
        options={[
          { label: targetQuarter, value: AppRoutes.regularPresent },
          { label: "過去提出分", value: AppRoutes.regularHistory },
        ]}
      >
        <Box
          border={`1px solid ${divider.middle}`}
          bgcolor={background.white}
          sx={{ borderBottomLeftRadius: rounded.sm, borderBottomRightRadius: rounded.sm }}
        >
          <Outlet />
        </Box>
      </Tab>
    </Box>
  );
};
